import { api, post } from '../../service';
import { ROLE_ADMIN, DIALOG_ADD } from '../../libs/enum';

const defaultForm = () => ({
    userId: 0,
    name: '',
    mobile: '',
    role: ROLE_ADMIN,
});
const defaultState = () => ({
    dialog: {
        visible: false,
        type: DIALOG_ADD,
    },
    form: defaultForm(),
    search: {
        size: 10,
        page: 1,
    },
    total: 0,
    users: [],
});

const moduleUser = {
    namespaced: true,
    state: defaultState(),
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        async getUsers({ commit, state }) {
            const res = await post(api.user.list, state.search);
            commit('changeUsers', res);
        },
        async addUser({ commit, dispatch, state }) {
            await post(api.user.add, state.form);
            commit('changeDialog', { visible: false });
            dispatch('getUsers');
        },
        async editUser({ commit, dispatch, state }) {
            await post(api.user.modifyRole, state.form);
            commit('changeDialog', { visible: false });
            dispatch('getUsers');
        },
        async enableUser({ dispatch }, data) {
            await post(api.user.enable, data);
            dispatch('getUsers');
        },
        changeDialog({ commit }, data) {
            commit('changeDialog', data);
        },
        changeForm({ commit }, data) {
            commit('changeForm', data);
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('getUsers');
        },
    },
    mutations: {
        resetState(state) {
            Object.assign(state, defaultState());
        },
        changeUsers(state, data) {
            const { users, totalCount } = data;
            state.total = totalCount;
            state.users = users;
        },
        changeDialog(state, data) {
            Object.assign(state.dialog, data);
            if (!data.visible) {
                state.form = defaultForm();
            }
        },
        changeForm(state, data) {
            Object.assign(state.form, data);
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default moduleUser;
